<template>
<div>
<button @click="$emit('click')" type="button"  class="btn btn-secondary  btn-block">
  
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    {{ btn_text }}
   
</button>  


</div>
</template>
<script>
export default {
  props: ['text'],
  data () 
  {
    return {
        
    }
    
    },
computed:{

    btn_text : function()
    {
        return this.text ? this.text : 'ANNULLA'
    }

    
}
 
}
</script>


